/* tslint:disable:no-console */

import { register } from 'register-service-worker';

if (process.env.NODE_ENV === 'production') {
  // notify user of available update
  const notifyUserUpdate = (worker: ServiceWorker) => {
    // update: skip confirmation and continue automatically
    worker.postMessage({action: 'skipWaiting'});
  };

  // refesh items on app ready
  // deprecated: now using apiConnector in Vue app
  // const refreshListitems = (worker: ServiceWorker) => {
  //   worker.postMessage({action: 'refreshListitems'});
  // };

  register(`${process.env.BASE_URL}service-worker.js`, {
    ready(registration) {
      console.log('EPD Archiv is being served from cache by a service worker.');
      // refreshListitems(registration.active);
    },
    registered() {
      console.log('Service worker has been registered.');
    },
    cached() {
      console.log('Content has been cached for offline use.');
    },
    updatefound() {
      console.log('New content is downloading.');
    },
    updated(registration) {
      console.log('New content is available; please refresh.');
      notifyUserUpdate(registration.waiting);
    },
    offline() {
      console.log('No internet connection found. App is running in offline mode.');
    },
    error(error) {
      console.error('Error during service worker registration:', error);
    },
  });

  // handle reload of window when SW is reloaded
  let refreshed = false;
  if (navigator.serviceWorker) {
    navigator.serviceWorker.addEventListener('controllerchange', () => {
      if (refreshed) {
        return;
      }
      window.location.reload();
      refreshed = true;
    });
  }
}
